            
<template>            
  <b-row style="padding-top: 10px;">
    <b-col class="text-right">
        <b-button 
          v-if="limpiar" 
          v-ripple="'rgba(255, 255, 255, 0.10)'" 
          size="sm" 
          class="ml-2" 
          @click="resetDataForm();resetCrud({state:'searchSw'});resetCrud({state:'swSearchs'});resetGlobal({state:'indexData'});resetCrud({state: 'dataMultiple'})" 
        >  Limpiar </b-button> 

        <b-button
          v-if="index===false && agregar"  
          v-ripple="'rgba(255, 255, 255, 0.10)'" 
          @click="save(true);resetCrud({state: 'dataMultiple'}) " 
          variant="outline-primary" 
          :disabled="invalid" 
          size="sm" 
          class="ml-2" 
          > Agregar {{nameBtn}} </b-button>

        <b-button  
          v-if="(index===false && dataPost[namePath].data.length===0 && saveConfig.capa===false && actualizar===false)" 
          v-ripple="'rgba(255, 255, 255, 0.10)'" 
          @click="save(false);resetCrud({state: 'dataMultiple'})"  
          :disabled="invalid" 
          variant="success" 
          size="sm" 
          class="ml-2" 
          >  Guardar {{nameBtn}}</b-button>
        
        <b-button  
          v-if="saveConfig.capa && actualizar===false && index===false" 
          disabled 
          variant="success" 
          size="sm" 
          class="ml-2 sw-save-loading" 
          ><div> <b-spinner variant="light" label="Spinning"></b-spinner></div>Guardar {{nameBtn}}</b-button>

        <b-button 
          v-if="index!==false && actualizar" 
          v-ripple="'rgba(255, 255, 255, 0.10)'" 
          @click="updateDataPost({ state:'data/'+indexData, data: dataForm[namePath]});resetGlobal({state:'indexData'});saveNotify(false,'Datos actualizados');resetCrud({state: 'dataMultiple'})" 
          variant="primary" 
          :disabled="invalid" 
          size="sm" class="ml-2" 
          > Actualizar {{nameBtn}}</b-button>

        
        <b-button 
          v-if="actualizar===false && saveConfig.capa===false && index!==false" 
          v-ripple="'rgba(255, 255, 255, 0.10)'" 
          @click="save(false);" 
          :disabled="invalid" 
          variant="primary" 
          size="sm" 
          class="ml-2"  
          > Actualizar {{nameBtn}}</b-button>
          
        <b-button  
          v-if="saveConfig.capa && actualizar===false && index!==false" 
          disabled 
          variant="primary" 
          size="sm" 
          class="ml-2 sw-save-loading" 
          ><div> <b-spinner variant="light" label="Spinning"></b-spinner></div>Actualizar {{nameBtn}}</b-button>

    </b-col>
  </b-row>              
</template>
<script>
import { mapState, mapActions } from "vuex"
export default 
{
  name: 'swfooterform',
  props:{
    limpiar: {
      type: Boolean,
      default: false
    },
    nameBtn: {
      type: String,
      default: ''
    },
    actualizar: {
      type: Boolean,
      default: false
    },
    agregar: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    index: {
      default: false
    }
  },
  computed: {    
  },
  methods: {
    save(value)
    {
      this.$emit('save',{save: value, ftn: 'guardarFtn'})
    },
    async saveNotify(error,color,title=false,content=false)
		{
			try{
				if(error) {
					await this.changeGlobal({ state: 'saveConfig/notification/error', boolean: true})
					await this.updateGlobal({ state: 'saveConfig/notification/title', data: 'No se guardaron los datos, intentalo de nuevo'})
				}
				if(content!==false) {
					await this.updateGlobal({ state: 'saveConfig/notification/content', data: content})
				}
				if(title!==false) {
					await this.updateGlobal({ state: 'saveConfig/notification/title', data: title})
				}
				await this.updateGlobal({ state: 'saveConfig/notification/color', data: color})
				await this.changeGlobal({ state: 'saveConfig/notification/view',  boolean: true})
				return !error
			}catch {

			}
		}, 
  }
}
</script>
<style>
.sw-save-loading{
  position:relative;
  color:transparent !important;
}
.sw-save-loading div{
  position: absolute;
  left: 0;
  right: 0
}
.sw-save-loading .spinner-border{
  width: 20px;
  height : 20px;
  border: 0.15em solid currentColor;
  border-right-color: transparent;
}
</style>